export const SET_TAB = 'SET_TAB'
export const SET_GENDER = 'SET_GENDER'
export const SET_AGE = 'SET_AGE'
export const SET_NOOF_PHOTOS= 'SET_NOOF_PHOTOS'
